import { ca } from '@cian/analytics';

import { createDeveloperProduct } from 'shared/utils/analytics';

/**
 * @description Событие: клик по точке прогресса (индикатору слайда) главной карусели.
 */
export function trackMainCarouselProgressDotClick(newbuildingId: number, slideIndex: number): void {
  ca('eventSite', {
    action: 'click_main_carousel_dot',
    category: 'Promo',
    label: 'main_carousel_dot_click',
    name: 'oldevent',
    products: [
      createDeveloperProduct({
        extra: {
          items: [
            {
              id: newbuildingId,
              offerType: 'newbuilding_id',
              position: slideIndex,
            },
          ],
        },
      }),
    ],
  });
}
